// services/userAccountService.js
import api from "./api";

export const getAllUsers = async () => {
  try {
    const response = await api.get("/users/");
    return response.data.results;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserDetails = async (id) => {
  try {
    const response = await api.get(`/users/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user details for id ${id}:`, error);
    throw error;
  }
};

export const getUsersWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-date_joined",
  role = "",
  status = "",
  organization = "",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (role) params.append("role", role);
    if (status) params.append("status", status);
    if (organization) params.append("organization", organization);

    const response = await api.get("/users/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching users with pagination:", error);
    throw error;
  }
};

// Optional: Add user management functions
export const createUser = async (userData) => {
  try {
    const response = await api.post("/users/", userData);
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/users/${id}/`, userData);
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    await api.delete(`/users/${id}/`);
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

// Optional: Add role management
export const assignUserRole = async (userId, roleData) => {
  try {
    const response = await api.post(`/users/${userId}/roles/`, roleData);
    return response.data;
  } catch (error) {
    console.error("Error assigning user role:", error);
    throw error;
  }
};

export const removeUserRole = async (userId, roleId) => {
  try {
    await api.delete(`/users/${userId}/roles/${roleId}/`);
  } catch (error) {
    console.error("Error removing user role:", error);
    throw error;
  }
};

// Optional: Add user preferences management
export const getUserPreferences = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}/preferences/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user preferences:", error);
    throw error;
  }
};

export const updateUserPreferences = async (userId, preferencesData) => {
  try {
    const response = await api.put(
      `/users/${userId}/preferences/`,
      preferencesData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user preferences:", error);
    throw error;
  }
};

// Optional: Add user activity tracking
export const getUserActivity = async (userId, timeframe = "week") => {
  try {
    const response = await api.get(`/users/${userId}/activity/`, {
      params: { timeframe },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user activity:", error);
    throw error;
  }
};

// Optional: Add bulk operations
export const bulkUpdateUsers = async (usersData) => {
  try {
    const response = await api.put("/users/bulk-update/", usersData);
    return response.data;
  } catch (error) {
    console.error("Error bulk updating users:", error);
    throw error;
  }
};
